import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './CustomToastStyles.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import './Travel_Desk.css';
import useAuth from './useAuth.js';
import './Loader.css';
//import { BASE_URL } from "./Constants.js";
import Select from 'react-select';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const Hotel_Request = () => {
    const [AdvanceStatus, setAdvanceStatus] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [EmpCode, setEmpCode] = useState('100076'); // Default Emp Code
    const [items, setItems] = useState([]); // Cities
    const [rows, setRows] = useState([{ id: Date.now(), emp_code: '', comp_name: '', dept_name: '', designation_name: '', grade: '', mobile: '' }]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [empCodes, setEmpCodes] = useState([]);
    const [filteredCodes, setFilteredCodes] = useState([]);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [currentInput, setCurrentInput] = useState('');
    useAuth();
    const [formData, setFormData] = useState({
        from_city: '',
        city: '',
        travel_date: '',
        booking_date: '',
        receipt: null,
        amount: '',
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, type, value, files } = e.target;
        if (type === 'file') {
            setFormData(prevState => ({
                ...prevState,
                [name]: files[0], // Get the file object directly
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleRowChange = (id, e) => {
        const { name, value } = e.target;
        setRows(prevRows =>
            prevRows.map(row => (row.id === id ? { ...row, [name]: value } : row))
        );
        if (name === 'emp_code') {
            setCurrentRowId(id);
            setCurrentInput(value);
            setFilteredCodes(empCodes.filter(code => code.includes(value)));
        }
    };

    const handleSelectCode = (code) => {
        setRows(prevRows =>
            prevRows.map(row => (row.id === currentRowId ? { ...row, emp_code: code } : row))
        );
        setCurrentInput(code);
        setFilteredCodes([]);
        fetchEmployeeDetails(code);
    };

    const handleAddRow = () => {
        setRows([...rows, { id: Date.now(), emp_code: '', comp_name: '', dept_name: '', designation_name: '', grade: '', mobile: '' }]);
    };

    const handleRemoveRow = (id) => {
        setRows(prevRows => prevRows.filter(row => row.id !== id));
    };

    const validateFormData = () => {
        const { comp_name } = formData;
        if (!comp_name) {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };

    const fetchCitiesData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}cities`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            if (result.status) {
                setItems(result.data);
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch cities data');
        }
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            setLoading(true); // Set loading to true at the start
            try {
                const token = localStorage.getItem('authToken');
                console.log("token1", token);
                const response = await fetch(`${API_BASE_URL}profile`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log("Profile data1:", result);

                if (result.status) {
                    const { profile, travel_advance } = result;

                    setEmpCode(profile.emp_code || '');
                    setAdvanceStatus(travel_advance?.advance_status || ''); // Safely access advance_status

                    const report_mngr = profile.report_mngr || '';
                    setFormData({
                        comp_name: profile.comp_name || '',
                        emp_code: profile.emp_code || '',
                        dept_name: profile.dept_name || '',
                        designation_name: profile.designation_name || '',
                        grade: profile.grade || '',
                        mobile: profile.mobile || '',
                        report_mngr: profile.report_mngr || '',

                    });
                } else {
                    setResponseMessage('Error: ' + result.message);
                }
            } catch (error) {
                console.error('Fetch error:', error);
                setResponseMessage('Error: ' + error.message);
            } finally {
                setLoading(false); // Set loading to false when done
            }
        };

        fetchProfileData();
    }, []);

    const fetchEmployeeDetails = async (empCode) => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${API_BASE_URL}users?emp_code=${empCode}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            if (result.status) {
                setRows(prevRows => {
                    const updatedRows = [...prevRows];
                    const rowIndex = updatedRows.findIndex(row => row.emp_code === empCode);
                    if (rowIndex !== -1) {
                        updatedRows[rowIndex].comp_name = result.user.comp_name;
                        updatedRows[rowIndex].dept_name = result.user.dept_name;
                        updatedRows[rowIndex].designation_name = result.user.designation_name;
                        updatedRows[rowIndex].grade = result.user.grade;
                        updatedRows[rowIndex].mobile = result.user.mobile;
                    }
                    return updatedRows;
                });
            } else {
                setError(result.message);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            setError('Failed to fetch employee details');
        }
    };

    useEffect(() => {
        fetchCitiesData();
    }, []);

    useEffect(() => {
        if (EmpCode) {
            fetchEmployeeDetails(EmpCode);
        }
    }, [EmpCode]);

    const handleBackClick = () => {
        navigate("/manage_hotel_request");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return; // Prevent multiple submissions
        }
        setIsSubmitting(true);

        // Simulate form submission (e.g., API call or any async operation)
        setTimeout(() => {
            // Reset isSubmitting after the submission is complete
            setIsSubmitting(false);

        }, 1000); // Simulating a 2-second delay for the submission process
        if (validateFormData()) {

            const isEmpCodeDuplicate = rows.some((row) => row.emp_code === formData.emp_code);

            if (isEmpCodeDuplicate) {
                // Show an error message if emp_code in any row matches the form's emp_code
                toast.error('In Sharing We need to add other BM ID');
                setIsSubmitting(false); // Allow submission again after showing the error
                return; // Prevent submission if duplicate emp_code is found
            }
            // Create a new FormData object
            const formDataToSend = new FormData();

            // Append all form fields to FormData
            for (const key in formData) {
                formDataToSend.append(key, formData[key]);
            }

            // Append rows data with incrementing keys
            if (formData.groupType === 'Shared') {
                rows.forEach((row, index) => {
                    formDataToSend.append(`rows[${index}][emp_code]`, row.emp_code);
                    formDataToSend.append(`rows[${index}][comp_name]`, row.comp_name);
                    formDataToSend.append(`rows[${index}][dept_name]`, row.dept_name);
                    formDataToSend.append(`rows[${index}][designation_name]`, row.designation_name);
                    formDataToSend.append(`rows[${index}][grade]`, row.grade);
                    formDataToSend.append(`rows[${index}][mobile]`, row.mobile);
                });
            }

            // Append the receipt file
            const receiptFileInput = document.querySelector('input[name="receipt"]');
            if (receiptFileInput && receiptFileInput.files.length > 0) {
                formDataToSend.append('receipt', receiptFileInput.files[0]); // Append the first selected file
            }

            console.log('Form submitted:', formDataToSend);

            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}postHotelRequest`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`, // Do not set 'Content-Type' for FormData
                    },
                    body: formDataToSend, // Directly use FormData as body
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                console.log('Response from server:', result);
                navigate("/manage_hotel_request");

                setShowPopup(true);
                // Handle successful response (e.g., show a success message)
            } catch (error) {
                console.error('Error submitting form:', error);
                toast.error('Error submitting form: ' + error.message);
            }
        }
        setIsSubmitting(false);
    };

    const handleCityChange = (selectedOption) => {
        setFormData(prevState => ({
            ...prevState,
            city: selectedOption ? selectedOption.value : '', // Set the selected city's value
        }));
    };

    const cityOptions = items.map(city => ({
        value: city.id,
        label: city.city_name,
    }));


    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0" style={{ fontSize: '20px' }}>Hotel Request Booking Info</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Travel Desk Booking Info</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="col-lg-12">
                        <div className="card" style={{ borderTop: '3px solid #00c0ef' }}>
                            <div className="card-body">

                                <form onSubmit={handleSubmit} encType="multipart/form-data" method="POST">
                                    <div className="box-body">
                                        <div className="row">

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Name </label>
                                                    <input
                                                        type="text"
                                                        name="comp_name"
                                                        id="name"
                                                        value={formData.comp_name}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Name"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Employee No/Consultant
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="emp_code"
                                                        id="name"
                                                        value={formData.emp_code}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Employee No/Consultant"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Department</label>
                                                    <input
                                                        type="text"
                                                        name="dept_name"
                                                        id="name"
                                                        value={formData.dept_name}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Department&Designation"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Designation </label>
                                                    <input
                                                        type="text"
                                                        name="designation_name"
                                                        id="name"
                                                        value={formData.designation_name}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Department&Designation"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Employee Band as per Category </label>
                                                    <input
                                                        type="text"
                                                        name="grade"
                                                        id="name"
                                                        value={formData.grade}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Employee Band as per Category"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Mobile No
                                                    </label>
                                                    <input

                                                        type="text"
                                                        name="mobile"
                                                        id="name"
                                                        value={formData.mobile}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        placeholder="Days of travel"
                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>



                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label style={{ fontSize: '12px' }} htmlFor="name">Reporting Manager
                                                    </label>
                                                    <input

                                                        type="text"
                                                        name="report_mngr"
                                                        id="report_mngr"
                                                        value={formData.report_mngr}
                                                        onChange={handleChange}
                                                        className="form-control input-font"

                                                        readonly="true"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="name">Single or Shared<span style={{ color: 'red' }}>*</span></label>
                                                    <br />

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            name="groupType"
                                                            id="Self"
                                                            value="Self"
                                                            checked={formData.groupType === 'Self'}
                                                            onChange={handleChange}
                                                            className="form-check-input"
                                                            required
                                                        />
                                                        <label htmlFor="Self" className="form-check-label">Single</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            name="groupType"
                                                            id="Shared"
                                                            value="Shared"
                                                            checked={formData.groupType === 'Shared'}
                                                            onChange={handleChange}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="Shared" className="form-check-label">Shared</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {formData.groupType === 'Shared' && (
                                            <div className="expense-table-container" style={{ textAlign: 'right' }}>
                                                <button type="button" onClick={handleAddRow} className="btn btn-primary">+</button>
                                                <table className="expense-table">
                                                    <thead>
                                                        <tr className="header-row">
                                                            <th>Shared By BMID<span style={{ color: 'red' }}>*</span></th>
                                                            <th>Name</th>
                                                            <th>Dept</th>
                                                            <th>Designation</th>
                                                            <th>Grade</th>
                                                            <th>Mobile</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {rows.map(row => (
                                                            <tr key={row.id}>
                                                                <td data-label="Emp Code">
                                                                    <input
                                                                        type="text"
                                                                        name="emp_code"
                                                                        value={row.emp_code}
                                                                        onChange={(e) => {
                                                                            handleRowChange(row.id, e);
                                                                            setEmpCode(e.target.value); // Update EmpCode state to trigger API fetch
                                                                        }}
                                                                        className="form-control input-font"

                                                                        required
                                                                    />
                                                                    {filteredCodes.length > 0 && (
                                                                        <ul className="suggestions">
                                                                            {filteredCodes.map((code) => (
                                                                                <li key={code} onClick={() => handleSelectCode(code)}>
                                                                                    {code}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    )}
                                                                </td>
                                                                <td data-label="Name">
                                                                    <input
                                                                        type="text"
                                                                        name="comp_name"
                                                                        value={row.comp_name}
                                                                        onChange={(e) => handleRowChange(row.id, e)}
                                                                        className="form-control input-font"
                                                                        placeholder="Name"
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td data-label="Dept">
                                                                    <input
                                                                        type="text"
                                                                        name="dept_name"
                                                                        value={row.dept_name}
                                                                        onChange={(e) => handleRowChange(row.id, e)}
                                                                        className="form-control input-font"
                                                                        placeholder="Dept"
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td data-label="Designation">
                                                                    <input
                                                                        type="text"
                                                                        name="designation_name"
                                                                        value={row.designation_name}
                                                                        onChange={(e) => handleRowChange(row.id, e)}
                                                                        className="form-control input-font"
                                                                        placeholder="Designation"
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td data-label="Grade">
                                                                    <input
                                                                        type="text"
                                                                        name="grade"
                                                                        value={row.grade}
                                                                        onChange={(e) => handleRowChange(row.id, e)}
                                                                        className="form-control input-font"
                                                                        placeholder="Grade"
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td data-label="Mobile">
                                                                    <input
                                                                        type="text"
                                                                        name="mobile"
                                                                        value={row.mobile}
                                                                        onChange={(e) => handleRowChange(row.id, e)}
                                                                        className="form-control input-font"
                                                                        placeholder="Mobile"
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td data-label="Actions">
                                                                    <button type="button" onClick={() => handleRemoveRow(row.id)} className="btn btn-danger">×</button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>)}

                                        <div className="row">

                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="city">City <span style={{ color: 'red' }}>*</span></label>

                                                    {/* React-Select for city */}
                                                    <Select
                                                        name="city"
                                                        value={cityOptions.find(option => option.value === formData.city)} // Find the selected city
                                                        onChange={handleCityChange}
                                                        options={cityOptions}
                                                        className="react-select-container" // Optional custom styles
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="check_in">Check-In <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="date"
                                                        name="check_in"
                                                        value={formData.check_in}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        required
                                                        min={new Date().toISOString().split("T")[0]} // Sets the minimum date to today
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="check_out">Check-Out <span style={{ color: 'red' }}>*</span></label>
                                                    <input
                                                        type="date"
                                                        name="check_out"
                                                        value={formData.check_out}
                                                        onChange={handleChange}
                                                        className="form-control input-font"
                                                        required
                                                        min={new Date().toISOString().split("T")[0]} // Sets the minimum date to today
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="hotel_name">Remarks </label>
                                                    <input
                                                        type="text"
                                                        name="hotel_name"
                                                        value={formData.hotel_name}
                                                        onChange={handleChange}
                                                        className="form-control input-font"

                                                        placeholder='Remarks'
                                                    // style={{ textTransform: 'uppercase' }}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="box-footer" style={{ textAlign: 'center' }}>
                                        <button type="submit" className="btn btn-success pull-right" disabled={isSubmitting}>Submit</button>
                                        <button
                                            className="btn btn-secondary  ml-3"
                                            onClick={handleBackClick} // Handle redirect
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
                <ToastContainer />
            </div>
        </div>
    );
};

export default Hotel_Request;
